<script setup lang="ts">
import { toRefs } from 'vue';
import { useTenantStore } from '@/store';
import { EMIT } from '@/enum';

const tenantStore = useTenantStore();

interface PropsInterface {
  id?: number;
  open: boolean;
}
const emit = defineEmits([EMIT.CANCEL, EMIT.UPDATE]);
const props = defineProps<PropsInterface>();
const { id, open } = toRefs(props);

const onCancel = () => emit(EMIT.CANCEL);

const onRestore = () => {
  if (id?.value) {
    tenantStore.restoreTenant(id.value);
    open.value = false;
  }
};
</script>

<template>
  <div>
    <ConfirmAction
      v-if="open"
      header="Restore Tenant"
      message="Are you sure you want to Restore this tenant?"
      accept-label="Restore"
      @accept="onRestore"
      @cancel="onCancel"
    >
      <div class="flex text-gray-800">
        <Icon name="warning" class="confirm-dialog-icon text-gray-600" />
        <span class="w-10 pl-3" v-text="`Are you sure you want to Restore this tenant?`" />
      </div>
    </ConfirmAction>
  </div>
</template>
